var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.564 8.61694C14.1838 8.61694 13.998 8.96317 13.8777 9.34706L13.5716 10.3248H12.5751C11.9342 10.3248 11.4182 10.8403 11.4182 11.4812V15.0413C11.4182 15.6822 11.9342 16.1983 12.5751 16.1983H19.2103C19.8512 16.1983 20.3673 15.6822 20.3673 15.0413V11.4812C20.3673 10.8403 19.8512 10.3248 19.2103 10.3248H18.2138L17.9076 9.34706C17.7875 8.96306 17.6015 8.61694 17.2214 8.61694H14.564ZM15.8926 11.3245C16.9622 11.3246 17.8292 12.1916 17.8293 13.2612C17.8295 14.331 16.9624 15.1985 15.8926 15.1985C14.8228 15.1985 13.9556 14.331 13.9558 13.2612C13.9559 12.1916 14.823 11.3246 15.8926 11.3245Z",
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon_photo.ca0af88c1ffd8d4ea4ff3de5a2866d6f.svg";
export { ForwardRef as ReactComponent };